// extracted by mini-css-extract-plugin
module.exports = {"name-section":"Description_name-section__zxDPX","name":"Description_name__ju_QL","error":"Description_error__4VdbJ"};